<template lang="pug">
  .container.grid-lg.py-2
    form.list-filters(@submit.prevent='listar')
      .columns.align-end.mb-2
        .column
          .columns.align-end
            .column.col-auto.form-group
              small {{ 'usuario.login' | tModel}}
              input-cpf-cnpj.input-sm.form-input(type='search' v-model='q.login_eq')
            .column.form-group
              small Nome
              input.input-sm.form-input(type='search' v-model='q.nome_cont', :placeholder="'usuario.nome' | tModel")
            .column.form-group
              small Perfil
                perfil-picker(v-model="q.perfis_id_eq" sm)
            .column.form-group
              small Departamento
                departamento-picker(v-model="departamento" sm)
            .column.col-auto.form-group
              small Tipo de usuário
              label.form-switch.input-sm
                input#prefeitura_eq(type='checkbox' v-model='q.prefeitura_eq')
                i.form-icon
                |  Prefeitura
            .column.col-auto.form-group.nowrap
              label.form-radio.form-inline.white.small.tooltip.tooltip-bottom(data-tooltip='Válidos')
                input(type='radio' v-model='q.ativo_eq', :value='true')
                i.form-icon
                |  Ativo
              label.form-radio.form-inline.white.small.tooltip.tooltip-bottom(data-tooltip='Cancelado ou não confirmado')
                input(type='radio' v-model='q.ativo_eq', :value='false')
                i.form-icon
                |  Inativo
        .column.col-auto.text-right
          button.btn.btn-link.tooltip.tooltip-bottom(type='submit', :data-tooltip="$i18n.t('views.buttons.filter.label')")
            i.fa.fa-search.fa-lg
    load-manager(:status='status')
      list-manager(:status='status', :count='list.length')
        .columns
          .column.col-6.col-md-12(v-for='u in list' :key='u.id')
            .my-2
              list-item-card
                div
                  .columns
                    .column
                      .h6.tooltip(:data-tooltip="'usuario.login' | tModel") {{ u.login }}
                    .column.col-auto
                      .small.tooltip(:data-tooltip="'usuario.validado_por' | tModel", :class='classValidadoPor(u.validado_por)') {{ u | enums('usuario.validado_por') }}
                  .small.tooltip(:data-tooltip="'usuario.nome' | tModel") {{ u.nome || '-' }}
                  .tooltip(:data-tooltip="'usuario.email' | tModel") {{ u.email || '-' }}
                .text-right(slot='footer')
                  router-link.btn.btn-link.tooltip(
                    :to="{name: 'app.sistema.usuarios.edit', params: {id: u.id}}",
                    :data-tooltip="$i18n.t('views.buttons.edit.label')"
                    v-acl:allowed.admin.sistema.usuarios.update
                  )
                    btn-icon.fa-lg(name='edit')
                  router-link.btn.btn-link.tooltip(
                    :to="{name: 'app.sistema.usuarios.show', params: {id: u.id}}",
                    :data-tooltip="$i18n.t('views.buttons.show.label')"
                    v-acl:allowed.admin.sistema.usuarios.show
                  )
                    btn-icon.fa-lg(name='show')
    .text-center
      btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
export default {
  vuex: {
    'sistema/usuarios': {
      state: ['list', 'status', 'page', 'pages', 'query', 'count'],
      getters: ['loading'],
      mutations: ['setQuery', 'setPage'],
      actions: ['fetchList', 'prevPage', 'nextPage', 'goPage'],
    },
  },
  data() {
    return {
      q: {
        cpf_cnpj_eq: '',
        razao_social_cont: '',
        ativo_eq: true,
        prefeitura_eq: true,
        perfis_id_eq: null,
      },
    }
  },
  methods: {
    toShow(item) {
      this.$router.push({
        name: 'app.sistema.usuarios.show',
        params: { id: item.id },
      })
    },
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
    classValidadoPor(validado_por) {
      switch (validado_por) {
        case 'eletronica':
        case 'certificado_digital':
        case 'pessoalmente':
          return 'text-success'
        case 'pergunta_seguranca':
        case 'codigo_verificacao':
          return 'text-warning'
        case 'nenhum':
          return 'text-error'
        default:
          return 'text-gray'
      }
    },
  },
  computed: {
    departamento: {
      get() {
        return this.q['perfis.perfilavel_id_eq']
      },

      set(departamentoId) {
        const departamento = {
          'perfis.perfilavel_id_eq': departamentoId || undefined,
          'perfis.perfilavel_type_eq': departamentoId
            ? 'Departamento'
            : undefined,
        }
        this.q = { ...this.q, ...departamento }
      },
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
